module.exports = __webpack_public_path__ + "static/img/verifiedBadge.31b2b939.png";